"use strict";
/* eslint-disable @typescript-eslint/no-namespace */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Multiaddr = exports.PeerID = void 0;
class PeerID {
    constructor(value) {
        this.value = value;
    }
    asObject() {
        return this.value;
    }
    toString() {
        return this.value;
    }
    static fromObject(value) {
        if (value instanceof PeerID)
            return value;
        return new this(value);
    }
}
exports.PeerID = PeerID;
class Multiaddr {
    constructor(value) {
        this.value = value;
    }
    static fromObject(obj) {
        if (obj instanceof Multiaddr) {
            return obj;
        }
        return new Multiaddr(obj);
    }
    asObject() {
        return this.value;
    }
}
exports.Multiaddr = Multiaddr;
//# sourceMappingURL=p2p.js.map